import { render, staticRenderFns } from "./VesselBuildersContacts.vue?vue&type=template&id=3c41614e&"
import script from "./VesselBuildersContacts.vue?vue&type=script&lang=js&"
export * from "./VesselBuildersContacts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports